import {toast} from "react-toastify";

export default error => {
  toast.error(error.message || "An Error Has Occurred");
  return false;
};